import React from "react";
import Header from "./Elements/Header/Header";
import Body from "./Elements/Body/Body";
import Footer from "./Elements/Footer/Footer";
import "./App.css";
import "./Variables.css";

function App() {
  return (
    <div id="fullPage">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default App;
